export const vowelsFull = [
  // Nguyên âm ngắn
  { letter: 'ະ', pronunciationVi: 'á' },
  { letter: 'ິ', pronunciationVi: 'í' },
  { letter: 'ຶ', pronunciationVi: 'ứ' },
  { letter: 'ຸ', pronunciationVi: 'ú' },
  { letter: 'ເະ', pronunciationVi: 'ế' },
  { letter: 'ແະ', pronunciationVi: 'é' },
  { letter: 'ໂະ', pronunciationVi: 'ố' },
  { letter: 'ເาะ', pronunciationVi: 'ó' },
  { letter: 'ເິ', pronunciationVi: 'ớ' },
  { letter: 'ເັຍະ', pronunciationVi: 'ía' },
  { letter: 'ເືອະ', pronunciationVi: 'ứa' },
  { letter: 'ົວະ', pronunciationVi: 'úa' },
  // Nguyên âm dài
  { letter: 'າ', pronunciationVi: 'a' },
  { letter: 'ີ', pronunciationVi: 'i' },
  { letter: 'ື', pronunciationVi: 'ư' },
  { letter: 'ູ', pronunciationVi: 'u' },
  { letter: 'ເ', pronunciationVi: 'ê' },
  { letter: 'ແ', pronunciationVi: 'e' },
  { letter: 'ໂ', pronunciationVi: 'ô' },
  { letter: 'ໍ', pronunciationVi: 'o' },
  { letter: 'ເີ', pronunciationVi: 'ơ' },
  { letter: 'ເຍ', pronunciationVi: 'ia' },
  { letter: 'ເືອ', pronunciationVi: 'ưa' },
  { letter: 'ົວ', pronunciationVi: 'ua' },
  // Nguyên âm đặc biệt
  { letter: 'ໄ', pronunciationVi: 'ay' },
  { letter: 'ໃ', pronunciationVi: 'ay' },
  { letter: 'ເົາ', pronunciationVi: 'âu' },
  { letter: 'ໍາ', pronunciationVi: 'ăm' },
];

export const vowelsGroup = {
  ngan: [
    { letter: 'ະ', pronunciationVi: 'á' },
    { letter: 'ິ', pronunciationVi: 'í' },
    { letter: 'ຶ', pronunciationVi: 'ứ' },
    { letter: 'ຸ', pronunciationVi: 'ú' },
    { letter: 'ເະ', pronunciationVi: 'ế' },
    { letter: 'ແະ', pronunciationVi: 'é' },
    { letter: 'ໂະ', pronunciationVi: 'ố' },
    { letter: 'ເาะ', pronunciationVi: 'ó' },
    { letter: 'ເິ', pronunciationVi: 'ớ' },
    { letter: 'ເັຍະ', pronunciationVi: 'ía' },
    { letter: 'ເືອະ', pronunciationVi: 'ứa' },
    { letter: 'ົວະ', pronunciationVi: 'úa' },
  ],
  dai: [
    { letter: 'າ', pronunciationVi: 'a' },
    { letter: 'ີ', pronunciationVi: 'i' },
    { letter: 'ື', pronunciationVi: 'ư' },
    { letter: 'ູ', pronunciationVi: 'u' },
    { letter: 'ເ', pronunciationVi: 'ê' },
    { letter: 'ແ', pronunciationVi: 'e' },
    { letter: 'ໂ', pronunciationVi: 'ô' },
    { letter: 'ໍ', pronunciationVi: 'o' },
    { letter: 'ເີ', pronunciationVi: 'ơ' },
    { letter: 'ເຍ', pronunciationVi: 'ia' },
    { letter: 'ເືອ', pronunciationVi: 'ưa' },
    { letter: 'ົວ', pronunciationVi: 'ua' },
  ],
  dacbiet: [
    { letter: 'ໄ', pronunciationVi: 'ay' },
    { letter: 'ໃ', pronunciationVi: 'ay' },
    { letter: 'ເົາ', pronunciationVi: 'âu' },
    { letter: 'ໍາ', pronunciationVi: 'ăm' },
  ]
}; 